import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/examSession';
import * as examSessionPageAction from '../actions/examSession';
import { Log } from 'ng2-logger';
import { ExamSessionService } from '../../api/exam-session-service';
import { QuestionService } from '../../api/question-service';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';
import Translator from '../../core/i18n';
import { IExamSessionAddAction, IExamSessionGetUpdate } from '../../models/action/examSession';
import { IExamSessionAddQuestion, IExamSessionAddStudent, IExamSessionAddStudentList, IExamSessionDeleteQuestion, IExamSessionDeleteStudent, IExamSessionGetStudentList, IExamSessionPublish, IExamSessionPublishDatas, IExamSessionQuestionList, IExamSessionStudentList } from '../../models/action/examSessionAdd';
import { IQuestionList } from '../../models/action/question';
const T = Translator.create();
const _logger = Log.create('Exam Session Saga');
const _examSessionService = new ExamSessionService();

function* getExamSessionList(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionListAsync({ ...params })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            yield put(examSessionPageAction.ExamSessionListSetAction(pageData, params.spinnerId, 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionSelected(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionSelectedAsync({ ...params })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            yield put(examSessionPageAction.ExamSessionSelectedSetAction(pageData, params.spinnerId, 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionAdd(params: IExamSessionAddAction) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionAddAsync(params.session)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            yield put(
                coreActions.newNotification(
                    params.session.examSessionId 
                        ? T.t('r_update_examsession_succesful_notification') 
                        : T.t('r_add_examsession_succesful_notification'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
            if (params.callback) {
                params.callback(pageData);
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionUpdate(params: IExamSessionGetUpdate) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionSelectedAsync({...params})
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            yield put(examSessionPageAction.ExamSessionSetUpdate(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionAddQuestionLists(params: IQuestionList) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    const _questionService = new QuestionService();
    try {
        const _yield = _questionService.RequestGetQuestionListsAsync({...params.filters, ...params.paging})
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            yield put(examSessionPageAction.SetExamSessionAddQuestionList(pageData.results, pageData.filters, params.spinnerId ? params.spinnerId : '', 'set'));
           
            if(params.callback)
            {
                params.callback();
            }

        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionAddQuestion(params: IExamSessionAddQuestion) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionAddQuestionAsync({ ...params.filters, ...params })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            Notification.setNotification('success', T.t('r_gen_exam_session_add_questions'), 'topRight');
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionDeleteQuestion(params: IExamSessionDeleteQuestion) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionDeleteQuestionAsync({ ...params })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            Notification.setNotification('success', T.t('r_gen_exam_session_delete_questions'), 'topRight');
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionQuestionLists(params: IExamSessionQuestionList) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionQuestionListsAsync({...params.filters, ...params.paging })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            yield put(examSessionPageAction.SetExamSessionQuestionList(pageData.results, pageData.filters, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionAddStudentLists(params: IExamSessionAddStudentList) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionAddStudentListsAsync({...params.filters, ...params.paging})
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            
            yield put(examSessionPageAction.SetExamSessionAddStudentList(pageData.results, pageData.filters, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });  
            if (pageData.filters && pageData.filters.total === 0) {
                Notification.setNotification('info', T.t('r_gen_exam_session_students_not_found'), 'topRight');
            }  
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionAddStudent(params: IExamSessionAddStudent) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionAddStudentAsync({ ...params.filters, ...params })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            Notification.setNotification('success', T.t('r_gen_exam_session_add_students'), 'topRight');
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionStudentLists(params: IExamSessionStudentList) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionStudentListsAsync({...params.filters, ...params.paging })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            yield put(examSessionPageAction.SetExamSessionStudentList(pageData.results, pageData.filters, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionGetStudent(params: IExamSessionGetStudentList) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionGetStudentAsync({...params })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            yield put(examSessionPageAction.SetExamSessionGetStudent(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionDeleteStudent(params: IExamSessionDeleteStudent) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionDeleteStudentAsync({ ...params })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            Notification.setNotification('success', T.t('r_gen_exam_session_delete_studentds'), 'topRight');
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionPublishDatas(params: IExamSessionPublishDatas) {

    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionPublishDatasAsync({ ...params })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            yield put(examSessionPageAction.SetExamSessionPublishDatas(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionPublish(params: IExamSessionPublish) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionPublishAsync({ ...params })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getExamSessionUnpublish(params: IExamSessionPublish) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        const _yield = _examSessionService.RequestGetExamSessionUnpublishAsync({ ...params })
        .then((responseData: Response) => {
            return responseData;
        })
        .then((responseData: Response) => {
            if(responseData.status !== 200) {
                isError = true;             
            }    
            return responseData.json();      
        }).then((response) => {
            if(isError) {
                errorList = response;
            } else {
                pageData = response;
            }
        });
        yield _yield;

        if (!isError) {
                Notification.setNotification('success', T.t('r_gen_exam_session_unpublished'), 'topRight');
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });    
        }
        
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* watchGetExamSessionList() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_LIST, getExamSessionList);
    return null;
}

function* watchGetExamSessionSelected() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_SELECTED, getExamSessionSelected);
    return null;
}

function* watchGetExamSessionAdd() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_ADD, getExamSessionAdd);
    return null;
}

function* watchGetExamSessionUpdate() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_UPDATE, getExamSessionUpdate);
    return null;
}

function* watchGetExamSessionAddQuestionLists() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_ADD_QUESTION_LIST, getExamSessionAddQuestionLists);
    return null;
}

function* watchGetExamSessionAddQuestion() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_ADD_QUESTION, getExamSessionAddQuestion);
    return null;
}

function* watchGetExamSessionDeleteQuestion() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_DELETE_QUESTION, getExamSessionDeleteQuestion);
    return null;
}

function* watchGetExamSessionQuestion() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_QUESTION_LIST, getExamSessionQuestionLists);
    return null;
}

function* watchGetExamSessionAddStudentLists() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_ADD_STUDENT_LIST, getExamSessionAddStudentLists);
    return null;
}

function* watchGetExamSessionAddStudent() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_ADD_STUDENT, getExamSessionAddStudent);
    return null;
}

function* watchGetExamSessionGetStudent() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_STUDENT_CHECK_LIST, getExamSessionGetStudent);
    return null;
}

function* watchGetExamSessionStudentLists() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_STUDENT_LIST, getExamSessionStudentLists);
    return null;
}

function* watchGetExamSessionDeleteStudent() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_DELETE_STUDENT, getExamSessionDeleteStudent);
    return null;
}

function* watchGetExamSessionPublishDatas() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_PUBLISH_DATAS, getExamSessionPublishDatas);
    return null;
}

function* watchGetExamSessionPublish() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_PUBLISH, getExamSessionPublish);
    return null;
}

function* watchGetExamSessionUnpublish() {
    yield takeEvery(constants.actions.GET_EXAM_SESSION_UNPUBLISH, getExamSessionUnpublish);
    return null;
}

export function* ExamSessionSagas() {
    yield all([
        watchGetExamSessionList(),
        watchGetExamSessionSelected(),
        watchGetExamSessionAdd(),
        watchGetExamSessionUpdate(),
        watchGetExamSessionAddQuestionLists(),
        watchGetExamSessionAddQuestion(),
        watchGetExamSessionQuestion(),
        watchGetExamSessionDeleteQuestion(),
        watchGetExamSessionAddStudentLists(),
        watchGetExamSessionAddStudent(),
        watchGetExamSessionStudentLists(),
        watchGetExamSessionDeleteStudent(),
        watchGetExamSessionPublishDatas(),
        watchGetExamSessionPublish(),
        watchGetExamSessionUnpublish(),
        watchGetExamSessionGetStudent()
    ]);
}
